import { SHADOW_COLOR_ONE, WHITE } from 'src/global/theme/colors';
import { makeStyles } from 'tss-react/mui';

export const styles = makeStyles()(() => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'row',
      boxSizing: 'border-box',
      width: 920
    },
    hasBackground: {
      borderRadius: "8px",
      backgroundColor: WHITE,
      boxShadow: SHADOW_COLOR_ONE
    },
    isDisabled: {
      opacity: 0.7,
      pointerEvents: 'none'
    },
    withPaddingDefault: {
      padding: "32px 88px"
    },
    fullContainer: {
      width: '100%'
    }
  };
});
